import { render, staticRenderFns } from "./ViewFileModal.vue?vue&type=template&id=1bc0d974"
import script from "./ViewFileModal.vue?vue&type=script&lang=js"
export * from "./ViewFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports